import {createParamSelector, getUseQueryResultData, Site, SiteEntity, transformSites} from "@ots-frontend/ots-data";
import {createSelector} from "@reduxjs/toolkit";
import {BBox, bboxPolygon, booleanPointInPolygon, point as turfPoint} from "@turf/turf";

type LocationHistoryMapSiteSelector = {
  showSites?: boolean
  bbox: BBox
}

const getSiteVisibilityParam = createParamSelector<LocationHistoryMapSiteSelector, boolean>(params => params?.showSites ?? true);
const getMinXParam = createParamSelector<LocationHistoryMapSiteSelector, number>(param => param.bbox[0]);
const getMinYParam = createParamSelector<LocationHistoryMapSiteSelector, number>(param => param.bbox[1]);
const getMaxXParam = createParamSelector<LocationHistoryMapSiteSelector, number>(param => param.bbox[2]);
const getMaxYParam = createParamSelector<LocationHistoryMapSiteSelector, number>(param => param.bbox[3]);

export const locationHistoryMapSiteSelector = () => createSelector(
  [getUseQueryResultData<Site[]>, getSiteVisibilityParam, getMinXParam, getMinYParam, getMaxXParam, getMaxYParam],
  (data, show, minX, minY, maxX, maxY) => {

    const filteredSites: SiteEntity[] = [];

    const sites = transformSites(data ?? []);
    if (show) {
      for (const site of sites) {
        if (site.latLng) {
          const point = turfPoint([site.latLng.latCoord, site.latLng.longCoord])
          const polygon = bboxPolygon([minX, minY, maxX, maxY])
          if (booleanPointInPolygon(point, polygon)) {
            filteredSites.push(site)
          }
        }
      }
    }

    return filteredSites;
  }
);
